import React, { useState, useEffect } from 'react';
import Sidebar from './comps/LeftSideBar';
import AnalyticsChart from './comps/MainContent';
import SectionSelector from './comps/SiteSelection';
import { useTheme } from '../../ThemeContext';
import ProjectNames from './dropdowns/Project';
import AddReport from './forms/AddReport';
import data from './data.json'; // Import your JSON data
import { Loader } from '@mantine/core'; // Import Mantine Loader

const Dashboard = () => {
  const { theme } = useTheme();
  const [manage, setManage] = useState(false);
  const [pname, setPname] = useState('');
  const [selectedStructure, setSelectedStructure] = useState([]); // Default empty array
  const [sections, setSections] = useState([]); // Default empty array
  const [filteredData, setFilteredData] = useState([]); // Default empty array
  const [uniqueStructures, setUniqueStructures] = useState([]); // To hold unique structures
  const [uniqueSections, setUniqueSections] = useState([]); // To hold unique sections
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [day, setDay] = useState('');
  const [loading, setLoading] = useState(true); // Loading state

  // Set the main content styles based on the theme
  const mainContent = theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-gray-100 text-black';
  const monthClass = theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-gray-100 text-black';
  const headerClass = theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-gray-100 text-black';

  // Extract unique structures and sections from data
  useEffect(() => {
    const structures = Array.from(new Set(data.map(item => item.Structure))); // Get unique structures
    setUniqueStructures(structures); // Set unique structures
  }, []);

  useEffect(() => {
    const sections = Array.from(new Set(data.map(item => item.Section))); // Get unique sections
    setUniqueSections(sections); // Set unique sections
  }, []);

  // Filter data based on selected filters (structure, section, date, and day)
  useEffect(() => {
    let filtered = data;

    if (selectedStructure.length) {
      filtered = filtered.filter(item => selectedStructure.includes(item.Structure));
    }

    if (sections.length) {
      filtered = filtered.filter(item => sections.includes(item.Section));
    }

    if (startDate && endDate) {
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.Date);
        const start = new Date(startDate);
        const end = new Date(endDate);
        return itemDate >= start && itemDate <= end;
      });
    }

    if (day) {
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.Date);
        return itemDate.toLocaleString('default', { weekday: 'long' }) === day;
      });
    }

    setFilteredData(filtered); // Set the filtered data
    setLoading(false); // Set loading to false after data is filtered
  }, [selectedStructure, sections, startDate, endDate, day]); // Run when any filter changes

  return (
    <div className="mtl-2 mr-2 relative">
      {/* Header */}
      <div className={`flex p-3 rounded-sm ${headerClass} justify-between items-center`}>
        <p className="text-xl font-bold">Reports</p>
        <ProjectNames
          filter={pname}
          handleChange={(e) => setPname(e.target.value)}
        />
        <button
          className="bg-blue-600 p-2 rounded-sm text-white font-semibold"
          onClick={(e) => setManage(true)}
        >
          Manage Report
        </button>
      </div>

      {/* Main Content */}
      <div className="flex h-screen mt-2">
        <div className={`${monthClass} mr-2`}>
          {/* Sidebar */}
          <Sidebar uniqueStructures={uniqueStructures} setSelectedStructure={setSelectedStructure} />
        </div>

        {/* Middle Content */}
        <div className={`flex-1 flex flex-col lg:flex-row ${mainContent} rounded-sm overflow-auto`}>
          <div className="flex-1 flex flex-col lg:flex-row">
            {/* Analytics Chart */}
            <div className="flex-1">
              {loading ? ( // Show loader while data is loading
                <div className="flex justify-center items-center h-full">
                  <Loader size="xl" />
                </div>
              ) : (
                <AnalyticsChart
                  structure={selectedStructure}
                  data={filteredData}
                  sections={sections}
                  startDate={startDate}
                  endDate={endDate}
                  day={day}
                />
              )}
            </div>
          </div>
        </div>

        {/* <div className={`${monthClass} ml-2`}>
          
          <SectionSelector
            setSelectedSections={setSections}
            uniqueSections={uniqueSections}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            startDate={startDate}
            endDate={endDate}
            day={day}
            setDay={setDay}
          />
        </div>
       */}
</div>
      {/* Manage Report Modal */}
      {manage && (
        <AddReport
          open={manage}
          onClose={(e) => setManage(false)}
          project={pname}
        />
      )}
    </div>
  );
};

export default Dashboard;
